import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { str } from '../_shared/blockRender.js';
import { MaterialIcon } from '../_shared/materialSymbols.js';
/**
 * `benefit-row` — ONE line of the {@link benefitPanelBlock}: a Material Symbols icon (name + optional
 * FILL + optional image override, the shared icon-with-text mechanism) followed by one line of text.
 *
 * It is a CHILD block of `benefit-panel`, so the seller adds / removes / reorders benefit lines in the
 * left tree — each with its own tidy inspector — instead of the old fixed wall of Icon-1/Text-1… fields
 * on the panel. As many rows as the seller wants (the panel's `accepts` gates the type; the section's
 * maxBlocks caps the total).
 *
 * SHARED STYLING is inherited from the parent panel so every row stays consistent without duplicating
 * size/colour controls per row: the icon SIZE flows through the `--aqx-icon-size` CSS var (MaterialIcon
 * reads it natively) and the icon COLOUR through `--aqx-bp-icon-color`; the row's TEXT size rides the
 * `font-size` the panel sets on the surrounding `<li>`.
 *
 * The panel owns that surrounding `<li>` (so it can drive the "View more" collapse + row spacing); this
 * block emits only the row's OWN content. An empty-text row renders nothing (the panel also filters it).
 */
export const benefitRowBlockSchema = {
    type: 'benefit-row',
    name: 'Benefit row',
    fields: [
        {
            id: 'icon',
            type: 'icon-name',
            label: 'Icon',
            default: 'check_circle',
            placeholder: 'check_circle',
        },
        {
            id: 'iconFill',
            type: 'checkbox',
            label: 'Filled icon',
            default: false,
        },
        {
            id: 'image',
            type: 'image',
            label: 'Image (overrides the icon)',
        },
        {
            id: 'text',
            type: 'text',
            label: 'Text',
            default: 'Nouvel avantage',
            defaultKey: 'section.new_benefit',
            maxLength: 120,
        },
    ],
};
const BenefitRowBlock = ({ block }) => {
    const bs = block.settings;
    const text = str(bs.text).trim();
    // A row with no text renders nothing — matches the panel's "only non-empty rows" behaviour and keeps a
    // freshly-cleared row from leaving an empty gap in the list.
    if (!text)
        return null;
    const iconWrap = { flex: '0 0 auto', lineHeight: 0 };
    return (_jsxs(_Fragment, { children: [_jsx("span", { style: iconWrap, children: _jsx(MaterialIcon, { name: str(bs.icon, 'check_circle'), filled: bs.iconFill === true, image: bs.image, 
                    // Fallback size only — the panel drives the real size via the inherited `--aqx-icon-size` var.
                    size: 20, color: "var(--aqx-bp-icon-color, var(--aqx-scheme-text))" }) }), _jsx("span", { children: text })] }));
};
export const benefitRowBlock = {
    type: 'benefit-row',
    schema: benefitRowBlockSchema,
    Component: BenefitRowBlock,
    meta: { label: 'Benefit row' },
};
//# sourceMappingURL=index.js.map